// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---JJLNW","changedRecordsList":"changedRecordsList---ZObdu","changedRecord":"changedRecord---EA6ab"};